import React from 'react'
import { FiEye, FiPlus, FiStar } from 'react-icons/fi'
import { Link } from 'react-router-dom'
import topTost from '../../utils/topTost';
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";

const CustomersViewHeader = () => {
           // 🌍 Kullanıcının dilini al ve çevirileri getir
   const userLanguage = useUserLanguage();
   const { translations: trans } = useTranslations(userLanguage);
   const getText = (key, defaultValue) => trans[key] || defaultValue;
    const handleClick = () => {
        topTost()
    };
    return (
        <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
            
            <Link to="/customers/create" className="btn btn-primary">
                <FiPlus size={16} className='me-2' />
                <span>{getText("ROLE_CREATE_TITLE")}</span>
            </Link>
        </div>
    )
}

export default CustomersViewHeader